import {
    GET_BRANCH_REQUEST, GET_BRANCH_SUCCESS, GET_BRANCH_FAIL,
    CREATE_BRANCH_REQUEST, CREATE_BRANCH_SUCCESS, CREATE_BRANCH_FAIL,
    UPDATE_BRANCH_REQUEST, UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAIL,
    DELETE_BRANCH_REQUEST, DELETE_BRANCH_SUCCESS, DELETE_BRANCH_FAIL
} from "../types/branchMasterTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'
import cogoToast from "cogo-toast";
import moment from "moment";
import CreateAxios from "../../components/axiosComponent/create";

export const deleteBranch = (branchId) => async (dispatch) => {

    dispatch({ type: DELETE_BRANCH_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
        }

        const { data } = await Axios.delete(`${APP_CONSTANT.BASE_URL}masters/branch/${branchId}`, {
            data: headerData,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            },
        });
        dispatch({ type: DELETE_BRANCH_SUCCESS, payload: data });

        if (data.status === 200) {
            cogoToast.success(data.message, { position: 'top-right' })
            setTimeout(() => {
                window.location.reload()
              }, 1000);
        } else {
            cogoToast.error(data.message, { position: 'top-right' })
        }



    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: DELETE_BRANCH_FAIL, payload: error.message })
    }
}

export const updateBranch = (branchData, branchId) => async (dispatch) => {

    dispatch({ type: UPDATE_BRANCH_REQUEST });

    try {

        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}masters/branch/${branchId}`, branchData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: UPDATE_BRANCH_SUCCESS, payload: data });
        if (data.status === 200) {
            if(branchData.serviceCategoryId && branchData.costCenter && branchId){
                try{
                    let payload = {
                      branchId,
                      serviceCategoryId : branchData.serviceCategoryId,
                      costCenter : branchData.costCenter
                    }
                    let mappingResponse = await CreateAxios({
                      completeURL: `${process.env.REACT_APP_BASE_URL}/masters/insertupdateBrachServiceCategoryMapping`,
                      payload
                    })
                    if(mappingResponse?.data?.status !== 200){
                      cogoToast.error(mappingResponse?.data?.message||"Unable to add service category details", { position: 'top-right' })
                    }
                  }catch(err){
                    console.log(err);
                  }
            }
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.reload()
            })
        } else {
            cogoToast.error(data.message, { position: 'top-right' })
        }


    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: UPDATE_BRANCH_FAIL, payload: error.message })
    }
}

export const createBranch = (branchData) => async (dispatch) => {

    dispatch({ type: CREATE_BRANCH_REQUEST });

    try {
        const { isGSTApplicable, isGSTExempted, gstNo, GSTExemptedReasonId, validityEndDate, validityStartDate } = branchData;
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            'branchName': branchData.branchName,
            'branchCode': branchData.branchCode,
            'address': branchData.address,
            'pincode': branchData.pincode,
            "gstChargeMechanism": branchData.gstChargeMechanism,
            isGSTApplicable,
            isGSTExempted,
            gstNo,
            GSTExemptedReasonId,
            validityEndDate: branchData.gstChargeMechanism ? validityEndDate : "",
            validityStartDate: branchData.gstChargeMechanism ? validityStartDate : "",
            ...branchData
        }
        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}masters/branch`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: CREATE_BRANCH_SUCCESS, payload: data });

        if (data.status === 200) {
            if(branchData.serviceCategoryId && branchData.costCenter && data.branchId){
                try{
                    let payload = {
                      branchId : data.branchId,
                      serviceCategoryId : branchData.serviceCategoryId,
                      costCenter : branchData.costCenter
                    }
                    let mappingResponse = await CreateAxios({
                      completeURL: `${process.env.REACT_APP_BASE_URL}/masters/insertupdateBrachServiceCategoryMapping`,
                      payload
                    })
                    if(mappingResponse?.data?.status !== 200){
                      cogoToast.error(mappingResponse?.data?.message||"Unable to add service category details", { position: 'top-right' })
                    }
                  }catch(err){
                    console.log(err);
                  }
            }
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.reload()
            })
        } else {
            cogoToast.error(data.message, { position: 'top-right' })
        }

    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: CREATE_BRANCH_FAIL, payload: error.message })
    }
}

export const getBranch = (id) => async (dispatch) => {

    dispatch({ type: GET_BRANCH_REQUEST });

    try {

        const headerData = {
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "batteryId": id ? id : ''
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}masters/branch`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_BRANCH_SUCCESS, payload: data });

    } catch (error) {
        if (error?.response?.data?.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_BRANCH_FAIL, payload: error.message })
    }
}